/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sourcestabfeedback2Inputs */

const en_sourcestabfeedback2 = /** @type {(inputs: Sourcestabfeedback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you've told the assistant`)
};

const pt_sourcestabfeedback2 = /** @type {(inputs: Sourcestabfeedback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que disse ao assistente`)
};

/**
* | output |
* | --- |
* | "What you've told the assistant" |
*
* @param {Sourcestabfeedback2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const sourcestabfeedback2 = /** @type {((inputs?: Sourcestabfeedback2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sourcestabfeedback2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sourcestabfeedback2(inputs)
	return pt_sourcestabfeedback2(inputs)
});
export { sourcestabfeedback2 as "sourcesTabFeedback" }